// extracted by mini-css-extract-plugin
export var label = "_bo-5";
export var slideContainer = "_bo-0";
export var slider = "_bo-1";
export var sliderLg = "_bo-4";
export var sliderMd = "_bo-3";
export var sliderSm = "_bo-2";